import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { type FusionStats } from '@ps/survey-utils';

import { FusionApi } from '../api/fusion.api';

@Injectable({ providedIn: 'root' })
export class FusionService {
  private readonly _api = inject(FusionApi);

  public createPriceBlock(surveyId: number): Observable<string> {
    return this._api.createPriceBlock(surveyId);
  }

  public resetFusionBlockStats(surveyId: number): Observable<string> {
    return this._api.resetFusionBlockStats(surveyId);
  }

  public getFusionStats(surveyId: number): Observable<FusionStats> {
    return this._api.getFusionStats(surveyId);
  }
}
